import { createFileRoute } from "@tanstack/react-router";
import { VisitsRedirect } from "@/components/app/portal/pages/visits-redirect";

export const Route = createFileRoute("/family-portal/visits/")({
  head: () => ({ meta: [{ title: "Video visits | People AI" }] }),
  component: VisitsRedirect,
});
